export default class TestJournalObject {
  public someField: string;
  constructor(someField: string) {
    this.someField = someField;
  }
}
